import axios from "../../axios";


export function zones__list() {
    return (async dispatch => {
        try {
            let response = await axios.get(`Zones?filter=${encodeURIComponent(JSON.stringify({
                include: {
                    relation: "checkpoints",
                    scope: {
                        order: "seq ASC"
                    }
                },
                order: "section ASC"
            }))}`);
            dispatch(
                {
                    type: "ZONES_LIST_FULFILLED",
                    payload: {
                        data: response.data,
                        error: null
                    }
                }
            )
        }
        catch (e) {
            dispatch({
                type: "ZONES_LIST_REJECTED",
                payload: {
                    data: null,
                    error: e
                }
            });
        }

    });
}
export function zones__create(zone, _name) {
    return (async dispatch => {
        try {
            await axios.post(`Zones`, zone);
            dispatch(zones__list());
            dispatch({
                type: "ZONES_UPDATE_ALERT",
                payload: {
                    type: _name,
                    status: {
                        id: '',
                        valid: true,
                        message: 'Zone Successfully created'
                    }
                }
            });
        }
        catch (error) {
            const err = error.response.data.error
            dispatch({
                type: "ZONES_UPDATE_ALERT",
                payload: {
                    type: _name,
                    status: {
                        id: err.name,
                        invalid: true,
                        message: `${err.message}`
                    }
                }
            });
        }
    });
}
export function zones__destroy(zoneId) {
    return (async dispatch => {
        try {
            let res = await axios.delete(`Zones/${zoneId}/checkpoints`);
            dispatch({ type: 'ZONES_CHECKPOINTS_DESTROYED_FULFILLED', payload: res.data })
            res = await axios.delete(`Zones/${zoneId}`);
            dispatch({ type: 'ZONES_DESTROYED_FULFILLED', payload: res.data })
            res = await zone_updateList();
            dispatch({ type: "ZONES_LIST_FULFILLED", payload: { data: res.data, error: null } })
        }
        catch (e) {
            dispatch({ type: 'ZONES_DESTROYED_REJECTED', payload: e.response.data.error })
        }
    })
}
export function zones__updateAttibutes(id, attributes, _name) {
    return (async dispatch => {
        try {
            await axios.patch(`Zones/${id}`, attributes);
            dispatch(
                zones__list()
            )
            dispatch({
                type: "ZONES_UPDATE_ALERT",
                payload: {
                    type: _name,
                    status: {
                        id: id,
                        valid: true,
                        message: 'Update Successful'
                    }
                }
            })
        }
        catch (error) {
            const err = error.response.data.error
            dispatch({
                type: "ZONES_UPDATE_ALERT",
                payload: {
                    type: _name,
                    status: {
                        id: id,
                        invalid: true,
                        message: `${err.name} : ${err.message}`
                    }
                }
            }
            );
        }
    })
}
export function zones__checkpointCreate(zoneId, point) {
    return (async dispatch => {
        try {
            let res = await axios.post(`Zones/${zoneId}/checkpoints`, point);
            dispatch({ type: 'ZONES_CHECKPOINTS_CREATE_FULFILLED', payload: res.data });
            dispatch({
                type: 'ZONES_UPDATE_ALERT', payload: {
                    type: '_point',
                    status: {
                        id: 'success',
                        zone: zoneId,
                        valid: true,
                        invalid: false,
                        message: 'Checkpoint has been created'
                    }
                }
            });
            res = await zone_updateList();
            dispatch({ type: "ZONES_LIST_FULFILLED", payload: { data: res.data, error: null } })
        }
        catch (res) {
            const err = res.response.data.error
            let status = {}
            dispatch({ type: 'ZONES_CHECKPOINTS_CREATE_REJECTED', payload: err })
            if (err.name === 'seq' || err.name === 'lat' || err.name === 'lng' || err.name === 'serial' || err.name === 'name') {
                status['id'] = err.name
            } else {
                status['id'] = 'fail'
            }
            status['zone'] = zoneId
            status['valid'] = false
            status['invalid'] = true
            status['message'] = err.message

            dispatch({
                type: 'ZONES_UPDATE_ALERT', payload: {
                    type: '_point',
                    status: status
                }
            })
        }
    })
}
export function zones__checkpointDestroy(zoneId, fk) {
    return (async dispatch => {
        try {
            let res = await axios.delete(`Zones/${zoneId}/checkpoints/${fk}`);
            dispatch({ type: 'ZONES_CHECKPOINTS_DELETE_FULFILLED', payload: res.data });
            res = await zone_updateList();
            dispatch({ type: "ZONES_LIST_FULFILLED", payload: { data: res.data, error: null } })
        }
        catch (res) {
            const err = res.response.data.error
            dispatch({ type: 'ZONES_CHECKPOINTS_DELETE_REJECTED', payload: err })
        }
    });
}
export function zones__checkpointUpdateAttribute(zoneId, fk, data, done) {
    return (async dispatch => {
        try {
            let res = await axios.put(`Zones/${zoneId}/checkpoints/${fk}`, data);
            dispatch({ type: 'ZONES_CHECKPOINTS_PUT_FULFILLED', payload: res.data })
            done();
            res = await zone_updateList();
            dispatch({ type: "ZONES_LIST_FULFILLED", payload: { data: res.data, error: null } })
        }
        catch (res) {
            if (res.response) {
                let err = res.response.data.error
                if (err.name === 'seq' || err.name === 'zoneId') {
                    err.message = 'X'
                }
                dispatch({ type: 'ZONES_CHECKPOINTS_PUT_REJECTED', payload: err })
                done({ valid: false, message: err.message })
            } else {
                console.log(res);
                dispatch({ type: 'ZONES_CHECKPOINTS_PUT_REJECTED', payload: "Error" })
                done({ valid: false, message: "Error" + res })
            }

        }
    })
}
export function zones__checkpointChangeZone(fk, data, done) {
    return (async dispatch => {
        try {
            dispatch({ type: 'ZONES_CHECKPOINTS_PUT_PENDING', payload: data })
            let res = await axios.patch(`Checkpoints/${fk}`, data);
            dispatch({ type: 'ZONES_CHECKPOINTS_PUT_FULFILLED', payload: res.data })
            done()
            res = await zone_updateList();
            dispatch({ type: "ZONES_LIST_FULFILLED", payload: { data: res.data, error: null } })
        }
        catch (res) {
            let err = res.response.data.error
            if (err.name === 'seq' || err.name === 'zoneId') {
                err.message = 'X'
            }
            dispatch({ type: 'ZONES_CHECKPOINTS_PUT_REJECTED', payload: err })
            done({ valid: false, message: err.message })
        }
    });
}
export function zones_dismissZoneAlert(id, type) {
    return (dispatch => {
        dispatch({
            type: "ZONES_UPDATE_ALERT",
            payload: {
                type: type,
                status: {
                    id: id,
                    valid: false,
                    invalid: false,
                    message: ''
                }
            }
        });
    })
}

async function zone_updateList() {
    try {
        return await axios.get(`Zones?filter=${encodeURIComponent(JSON.stringify({
            include: {
                relation: "checkpoints",
                scope: {
                    order: "seq ASC"
                }
            },
            order: "section ASC"
        }))}`);
    }
    catch (error) {
        return Promise.reject(error);
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/zones.js